import { render } from "./RaceEvent.vue?vue&type=template&id=31a19aa3"
import script from "./RaceEvent.vue?vue&type=script&lang=js"
export * from "./RaceEvent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__